import { useSelector } from 'react-redux';
import { can } from 'store/authentication/selectors';

export default function useCan(...args) {
  return useSelector((state) => can(state, ...args));
}
